export default __webpack_public_path__ + "static/class-management-3de86949706807d78e566f353859e76e.png";